import type { ComponentMeta } from "@mijalowcode/types";
import { ButtonMeta } from "./components/Button/meta";
import { ContainerMeta } from "./components/Container/meta";
import { ImageMeta } from "./components/Image/meta";

export const h5ComponentMetaMap: Record<string, ComponentMeta> = {
  Button: ButtonMeta,
  Container: ContainerMeta,
  Image: ImageMeta,
};

export function getH5ComponentMeta(componentName: string): ComponentMeta | null {
  return h5ComponentMetaMap[componentName] || null;
}

export function getAllH5ComponentMetas(): ComponentMeta[] {
  return Object.values(h5ComponentMetaMap);
}
